import classNames from 'classnames';
import { ForwardedRef, ReactElement } from 'react';

import List, { ListItem, ListProps } from './List';

import styles from '../../styles/lists/row-list.module.css';

export interface RowListProps<Item = ListItem> extends ListProps<Item> {
    withoutScrollSnap?: boolean;
}

function RowList<Item = ListItem>({
    cardWidth = null,
    withoutScrollSnap = false,
    className = null,
    itemsClassName = null,
    itemClassName = null,
    cardClassName = null,
    ref: listRef = null,
    ...props
}: RowListProps<Item> & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <List<Item>
            {...props}
            ref={listRef}
            cardWidth={cardWidth}
            itemStyle={{
                maxWidth: cardWidth,
                minWidth: cardWidth,
            }}
            className={classNames([
                styles.container,
                'drag-disabled',
                className,
                !withoutScrollSnap ? styles.scrollSnap : null,
            ])}
            itemsClassName={classNames([styles.items, itemsClassName])}
            itemClassName={classNames([styles.item, itemClassName])}
            cardClassName={classNames([styles.card, cardClassName])}
        />
    );
}

export default RowList as <Item = ListItem>(
    props: RowListProps<Item> & { ref?: ForwardedRef<HTMLDivElement> },
) => ReactElement;
